import React, {BaseSyntheticEvent} from "react";
import {Container, Text} from "../../ui";
import {Control, Controller} from "react-hook-form";
import {EMAIL_REGEX} from "../../constants";
import {Dialog, TextField} from "../bounce-ui";

export type FormValues = {
  email: string;
  message: string;
};

interface ContactUsFormProps {
  onSubmit: (e?: BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
  isValid: boolean;
  control: Control<FormValues, any, FormValues>;
}

export const ContactUsForm = ({onSubmit, isValid, control}: ContactUsFormProps) => {
  return (
    <Dialog title={"How can we help?"} buttonText={"Send"} onClick={onSubmit} disabled={!isValid}>
      <Text>Send us a message below, and we will contact you shortly.</Text>
      <form style={{width: "100%"}}>
        <Container sx={{gap: "8px", alignItems: "start", height: "300px"}}>
          <Controller
            name="email"
            rules={{
              required: "Required field",
              pattern: {value: EMAIL_REGEX, message: "Invalid email"},
            }}
            control={control}
            defaultValue=""
            render={({field: {ref, ...field}, fieldState: {invalid, error}}) => {
              return (
                <TextField
                  {...field}
                  inputRef={ref}
                  fullWidth
                  label={"Email"}
                  type="email"
                  error={invalid}
                  helperText={error?.message}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              );
            }}
          />
          <Controller
            name="message"
            rules={{
              required: "Required field",
            }}
            control={control}
            defaultValue={""}
            render={({field: {ref, ...field}, fieldState: {invalid, error}}) => {
              return (
                <TextField
                  {...field}
                  placeholder={"Type Your Message Here"}
                  inputRef={ref}
                  variant={"outlined"}
                  margin="normal"
                  required
                  fullWidth
                  type="text"
                  multiline
                  rows={9}
                  autoComplete="off"
                  error={invalid}
                  helperText={error?.message}
                  InputLabelProps={{required: false}}
                  inputProps={{
                    maxLength: 1024,
                  }}
                  sx={{margin: "0px"}}
                />
              );
            }}
          />
        </Container>
      </form>
    </Dialog>
  );
};
